import { useCallback, useEffect, useState } from 'react'
import { FeedInPowerModel } from '../model'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { fetchFeedInPower } from '../api/feed-in-power.api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'

interface FeedInPowerHook {
  isLoading: boolean
  feedInPowerData?: FeedInPowerModel
  error?: Error | AuthFetchError
  getFeedInPowerData: (storageId?: string) => Promise<void>
}

/**
 * Hook handles feed-in-power-data by fetching data from BE and return the data or error
 *
 * @param storageId
 * @returns
 */
const useFeedInPowerData = (storageId?: string): FeedInPowerHook => {
  const authFetch = useAuthFetchWithResponse()
  const [feedInPowerData, setFeedInPowerData] = useState<FeedInPowerModel>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | AuthFetchError>()

  const getFeedInPowerData = useCallback(
    async (storageId?: string) => {
      try {
        const feedInPowerDataResponse = await fetchFeedInPower(storageId, authFetch)
        if (feedInPowerDataResponse.hasErrors) setError(feedInPowerDataResponse.error)
        if (feedInPowerDataResponse.value) setFeedInPowerData(feedInPowerDataResponse.value)
      } catch (error) {
        setError(error as Error)
      }
    },
    [authFetch]
  )

  useEffect(() => {
    setIsLoading(true)
    getFeedInPowerData(storageId).finally(() => {
      setIsLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageId])

  return { isLoading, feedInPowerData, error, getFeedInPowerData }
}

export default useFeedInPowerData
